<template>
    <div>
        <div class="text-a-blue-1c3e95 text-24 text-center">{{lbl.transfer.title}}</div>
        <div class="text-center text-tc-black-1 text-20 pt-4">
            {{lbl.transfer.title2}}
            <!-- <br>{{lbl.transfer.title3}} -->
        </div>
        <div class="pt-4 flex justify-center mx-auto">
            <InputContactNumber
                v-model:inputValue="form.contactNumber"
                :errorInfo="errorInfo[0]"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :inputLbl="lbl.transfer.contactNumber"
                :minLength="10"
                :maxLength="10"
                class="sm:w-80 w-full"
            ></InputContactNumber>
        </div>
        <div class="pt-4 flex justify-center mx-auto">
            <InputNumber
                v-model:inputValue="form.point"
                :errorInfo="errorInfo[1]"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :inputLbl="lbl.transfer.point"
                class="sm:w-80 w-full"
            ></InputNumber>
        </div>
    </div>
</template>

<script>
import InputContactNumber from '@/components/Input/label/InputContactNumber.vue';
import InputNumber from '@/components/Input/label/InputNumber.vue';
import LocaleMixin from '@/mixin/LocaleMixin';
import { FormHelper } from '@/helper/FormHelper'
export default {
    name: 'FormTransferPoint',
    components:{
        InputContactNumber,
        InputNumber
    },
    mixins: [LocaleMixin],
    data() {
        return {
            form:{
                contactNumber: '',
                point: ''
            },
            errorInfo: FormHelper.genErrorInfo(2),
            isFirstSave: true
        };
    },

    created() {

    },

    methods: {
         validateForm:function(){
            this.isFirstSave = false;
            let validate = FormHelper.validate(this.errorInfo);
            if(validate){
                return this.form;
            }
            return validate;
        },
    },
};
</script>

<style lang="scss" scoped>

</style>
